'use client';

import FaqList from '@/components/Layouts/Default/FaqList';
import { Tab, Tabs } from "@heroui/tabs";
import { useParams, useRouter } from 'next/navigation';
import { Key } from '@react-types/shared';
import React from 'react';
import PageTitle from '@/components/Layouts/Default/PageTitle';
import { getFAQCATEGORYDATA } from './data';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';

const FaqCategoryTabs = () => {
  const params = useParams();
  const router = useRouter();
  const t = useTranslations();
  const FAQCATEGORYDATA = getFAQCATEGORYDATA(t);
  const [activeTabState, setActiveTab] = React.useState<Key>(
    FAQCATEGORYDATA.find((data) => data.key === params.category)?.key ||
      'get-started'
  );

  const selectedTab = React.useMemo(
    () => FAQCATEGORYDATA.find((data) => data.key === activeTabState),
    [activeTabState, t]
  );

  const handleTabChange = (key: Key) => {
    setActiveTab(key);
    router.replace(`/faq/${key}`);
  };

  return (
    <div className="flex justify-center">
      <div className="max-w-full min-w-0">
        <PageTitle
          title={selectedTab?.name}
          description={selectedTab?.description}
        />
        <div className="max-w-full border rounded-[10px] border-gray-light2 gap-4 mx-3">
          <div className="col-span-full grid lg:grid-cols-5">
            {FAQCATEGORYDATA.slice(0, 5).map((data) => (
              <div
                key={data.key}
                className={clsx(
                  'px-4 h-[50px] flex items-center text-nowrap justify-center text-center flex-shrink-0 body-semibold hover:text-gray-light transition-all duration-400 cursor-pointer',
                  {
                    'text-primary-blue hover:text-primary-blue':
                      data.key === activeTabState,
                    'text-gray-medium': data.key !== activeTabState,
                  }
                )}
                onClick={() => handleTabChange(data.key)}
              >
                {data.name}
              </div>
            ))}
          </div>
          <div className="col-span-full grid lg:grid-cols-2 ">
            {FAQCATEGORYDATA.slice(5).map((data) => (
              <div
                key={data.key}
                className={clsx(
                  'px-4 h-[50px] flex items-center text-nowrap justify-center text-center flex-shrink-0 body-semibold hover:text-gray-light transition-all duration-400 cursor-pointer',
                  {
                    'text-primary-blue': data.key === activeTabState,
                    'text-gray-medium': data.key !== activeTabState,
                  }
                )}
                onClick={() => handleTabChange(data.key)}
              >
                {data.name}
              </div>
            ))}
          </div>
        </div>
        <Tabs
          classNames={{
            base: 'w-full hidden',
            tabContent:
              'text-gray-medium body-semibold group-data-[selected=true]:!text-primary-blue !max-w-full',
            tabList:
              '!p-0 w-full h-[68px]  bg-transparent border items-stretch',
            tab: '!h5 h-full !font-medium',
            panel: 'pt-16 !max-w-full',
            cursor: 'shadow-none group-data-[selected=true]:bg-transparent',
          }}
          selectedKey={activeTabState}
          onSelectionChange={handleTabChange}
        >
          {FAQCATEGORYDATA.map((data) => (
            <Tab
              key={data.key}
              title={data.name}
              className="w-full flex flex-col justify-center items-center"
            >
              <FaqList data={data.questions} className=" w-full " />
            </Tab>
          ))}
        </Tabs>
      </div>
    </div>
  );
};

export default FaqCategoryTabs;
